export default defineNuxtPlugin(async (nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  if (runtimeConfig.public.packageType === 'client') {
    const fp = await window.FingerprintJS.load()
    nuxtApp.provide('agent', fp)
  }
})
